module.exports = __webpack_public_path__ + "static/media/ico-kushki.2ccdade9.svg";